module.exports = __webpack_public_path__ + "img/course-cover01.2fc79b97.jpg";